import { Button } from 'react-bootstrap';

import { CONFIG } from '../config';

export function ReportButton({
  file,
  proposal,
}: {
  file: string;
  proposal: string;
}) {
  const { DOWNLOAD_REPORT_LINK: downloadUrl } = CONFIG;
  const link = `${downloadUrl}${file}`.replaceAll('{proposal}', proposal);

  return (
    <Button href={link} size="sm" target="_blank" rel="noopener noreferrer">
      {file}
    </Button>
  );
}
